import { createContext, useContext, useEffect } from "react";

/**
 * Iter 127 (Feb 2026) — light mode only, forced.
 *
 * Per product owner: "no more dark mode, light mode only." The theme
 * toggle previously produced half-baked hybrid pages (dark cards on a
 * light section background) that ended up with invisible text
 * everywhere. Rather than maintain both palettes, we hard-lock the
 * app to `theme-light` and hide the toggle. The context still exists
 * so components can call `useTheme()` without crashing.
 */

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add("theme-light");
    // Wipe any stale value so a user who previously flipped to dark
    // doesn't get an inconsistent state on reload.
    try { localStorage.setItem("pff_theme", "light"); } catch { /* ignore */ }
  }, []);

  const value = { theme: "light", setTheme: () => {}, toggle: () => {} };
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) return { theme: "light", setTheme: () => {}, toggle: () => {} };
  return ctx;
}
